"use client";

import { usePathname } from "next/navigation";
import enMessages from "@/i18n/messages/en.json";
import trMessages from "@/i18n/messages/tr.json";

export default function RootError({ reset }: { reset: () => void }) {
  const pathname = usePathname();
  const isTr = pathname?.startsWith("/tr");
  const messages = isTr ? trMessages.error : enMessages.error;

  return (
    <div style={{ minHeight: "40vh", display: "grid", placeItems: "center", gap: 12 }}>
      <h2>{messages.somethingWentWrong}</h2>
      <button type="button" onClick={reset} style={{ padding: "8px 14px", cursor: "pointer" }}>
        {messages.retry}
      </button>
    </div>
  );
}
